import { PaymentInfo, PaymentHistory, PAYMENT_STATUS } from "@/types/payment.type";

export interface PaymentsNegativation {
  _id: string;
  description: string;
  status?: PAYMENT_STATUS
  value: number;
  history?: PaymentHistory[];
  split?: boolean;
  splitPercentualValue?: number;
  splitValue?: number;
  externalPaymentId?: string;
}

export interface PaymentTotals {
  totalValue: number;
  totalSplitValue: number;
  splitPercentOnTotal: number;
}


export const convertToNegativationPayments = (paymentsValid: PaymentInfo[]): PaymentsNegativation[] => {
  return paymentsValid.map((payment) => ({
    _id: payment._id,
    description: payment.description,
    value: payment.value,
    history: payment.history,
    externalPaymentId: payment.externalPaymentId,
    status: payment.status,
  }));
};


export const calculatePaymentTotals = (selectedPayments: PaymentsNegativation[]): PaymentTotals => {
  const totalValue = Number(
    selectedPayments.reduce((total, payment) => total + payment.value, 0).toFixed(2)
  );

  const totalSplitValue = selectedPayments.reduce((total, payment) => {
    const historyData = payment.history && payment.history.length > 0
      ? payment.history[payment.history.length - 1]?.data
      : undefined;
    const existeSplit = historyData?.split && historyData.split.length > 0;
    const splitValue = existeSplit ? historyData.split[0].totalValue : 0;
    return total + (existeSplit ? splitValue : 0);
  }, 0);

  const splitPercentOnTotal = totalValue > 0 ? (totalSplitValue / totalValue) * 100 : 0;

  return { totalValue, totalSplitValue, splitPercentOnTotal };
};


export const formatPaymentsForTable = (selectedPayments: PaymentsNegativation[]) => {
  return selectedPayments.map((paymentSelected: PaymentsNegativation) => {
    const historyData = paymentSelected.history && paymentSelected.history.length > 0
      ? paymentSelected.history[paymentSelected.history.length - 1]?.data
      : undefined;

    const existeSplit = historyData?.split && historyData.split.length > 0;
    const splitValue = existeSplit ? historyData.split[0].totalValue : undefined;
    const percentualValue = existeSplit ? historyData.split[0].percentualValue : undefined;

    return {
      description: paymentSelected.description,
      value: `R$ ${paymentSelected.value.toFixed(2)}`,
      split: existeSplit ? "Sim" : "Não",
      splitValue: existeSplit ? `R$ ${splitValue.toFixed(2)}` : "N/A",
      splitPercentualValue: existeSplit ? `${percentualValue?.toFixed(4)}%` : "N/A",
    };
  });
};
